import { HttpRequest } from './HttpRequest';
import { PWR_APIS } from './APIs';

export default class pwrService {

    http = new HttpRequest();

    savePatientData(data) {
        return this.http.post(PWR_APIS.GET_SAVE_PATIENT,data);
    }

    validateLicenceAPI(data){
        return this.http.post(PWR_APIS.VALIDATE_LICENCE,data);
    }

}